import { DirectoryRecordData } from 'api/types/data';
import { OrderOperationType } from 'api/types/entity/account/order';

import { useField } from '../../../forms/orderForm';
import { useOrderContext } from '../../../providers/OrderProvider';

import { SenderOrRecipientDetailsSectionProps } from './types';

const CUSTODIAN_ORGANIZATION_CODE_FIELD_NAME = 'code';

export const useSenderOrRecipientDetailsSection = ({
  type,
}: SenderOrRecipientDetailsSectionProps) => {
  const { orderType, directories, isDisabledDirectoryFreeSolo } =
    useOrderContext();

  const detailsFieldName =
    type === 'recipient' ? 'recipientDetails' : 'senderDetails';

  const { helpers: custodianOrganizationCodeHelpers } = useField(
    `${detailsFieldName}.custodianOrganizationCode`
  );

  const { senderOrRecipientDetails } = directories;

  let isDisabledAccountNumber = false;
  let isDisabledAccountOwnerName = false;
  let isDisabledBrokerName = false;

  if (orderType === OrderOperationType.SecuritiesWithdrawal) {
    isDisabledAccountNumber = type === 'sender';
    isDisabledAccountOwnerName = type === 'sender';
    isDisabledBrokerName = type === 'sender';
  } else if (orderType === OrderOperationType.SecuritiesDeposit) {
    isDisabledAccountNumber = type === 'recipient';
    isDisabledAccountOwnerName = type === 'recipient';
    isDisabledBrokerName = type === 'recipient';
  }

  const onChangeCustodianOrganization = (
    params: {
      value: string;
      label: string;
      record?: DirectoryRecordData;
    } | null
  ) => {
    if (params?.record) {
      const { record } = params;

      const code = record.fields.find(
        (field) => field.name === CUSTODIAN_ORGANIZATION_CODE_FIELD_NAME
      );

      custodianOrganizationCodeHelpers.setValue(
        code?.value?.toString() || undefined
      );
    } else {
      custodianOrganizationCodeHelpers.setValue(undefined);
    }
  };

  return {
    isDisabledAccountNumber,
    isDisabledAccountOwnerName,
    isDisabledBrokerName,
    senderOrRecipientDetails,
    isDisabledDirectoryFreeSolo,
    onChangeCustodianOrganization,
  };
};
